import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ShowRedeemBrandCoupon from "../../../components/SuperAdmin/RedeemBrandCoupon/ShowRedeemBrandCoupon";

export default withRouter(connect()(ShowRedeemBrandCoupon));
